










































































import { Vue, Component } from 'vue-property-decorator';
import { Toast, List, Loading } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getNewsList, getShowList, getNewstpList } from '../api';
import NewsItem from '../components/NewsItem.vue';
import { getChannelList, getChannelList1 } from '../api/util';
import { getBaseInfo } from '../api';
import qs from 'qs';
import { nextTick } from 'vue';
Vue.use(Loading)
  .use(List)
  .use(Toast);
@Component({
  components: {
    NewsItem,
    List,
  },
})
export default class Home extends Vue {
  currentArch: string = '';
  newsList: any[] = [];
  imgsList: any[] = [];
  isshowimg: boolean = false;
  showimginx: number = -1;
  loading: boolean = false;
  finished: boolean = false;
  firstfinished: boolean = false;
  loading1: boolean = false;
  finished1: boolean = false;
  isShowList: boolean = true;
  tabs: any[] = [];
  inx: number = -1;
  page: number = 1;
  pageSize: number = 6;
  baseInfo: any = {};

  async created() {
    this.tabs = getChannelList();
    let id = this.$route.query.id as string;
    let nowinx = window.localStorage.getItem('nowinx');
    if (!id) {
      if (!nowinx) {
        this.currentArch = this.tabs[0].id;
      } else {
        const inxtab = parseInt(nowinx);
        this.currentArch = this.tabs[inxtab].id;
      }
    } else {
      this.currentArch = id;
    }
    const tabs1 = getChannelList1();
    for (let i = 0; i < tabs1.length; i++) {
      if (this.currentArch === tabs1[i]) {
        window.localStorage.setItem('nowinx', i + '');
        this.inx = i;
        break;
      }
    }
    // this.loadData();
    setTimeout(() => {
      // const navBar = this.$refs.navBar as HTMLDivElement;
      const target = (document.querySelector(
        `div[arch="${this.currentArch}"]`,
      ) as HTMLDivElement).offsetLeft;
      // console.log(navBar, target)
      (this.$refs.navBar as HTMLDivElement).scrollTo({
        left: target,
        behavior: 'smooth',
      });
    }, 500);
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    console.log('baseinfo:', ret.data);
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  loadData1() {
    this.$nextTick(() => {
      getShowList().then((res: any) => {
        if (res.code === 200) {
          if (!res.data) {
            this.loading1 = false;
            this.finished1 = true;
            return;
          }
          const data = JSON.parse(res.data);
          data.forEach((item: any) => {
            item.imageUrl = item.imageUrl.split('|');
            item.showType = '0099';
            this.currentArch = '0099';
            this.imgsList.push(item);
          });
          this.loading1 = false;
          this.finished1 = true;
        }
      });
    });
  }
  gettoplist() {
    getNewstpList({
      page: this.page,
      classId: this.currentArch,
      newsType: 'top',
    })
      .then((res: any) => {
        if (res.statusCode !== 200) {
          Toast(res.message);
          return;
        }
        const list =
          res.data &&
          res.data.data instanceof Array &&
          res.data.data.length > 0 &&
          res.data.data[0].list instanceof Array
            ? res.data.data[0].list
            : [];
        this.newsList = [...this.newsList, ...list];

        this.finished = list.length < this.pageSize; // 加载完成
        if (!this.finished) {
          this.page++;
        }
      })
      .catch(() => {
        Toast('网络错误');
        this.loading = false;
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  loadData() {
    if (this.inx === 1) {
      getNewstpList({
        page: this.page,
        classId: this.currentArch,
        newsType: 'top',
      })
        .then((res: any) => {
          if (res.statusCode !== 200) {
            Toast(res.message);
            return;
          }
          const list =
            res.data &&
            res.data.data instanceof Array &&
            res.data.data.length > 0 &&
            res.data.data[0].list instanceof Array
              ? res.data.data[0].list
              : [];
          this.newsList = [...this.newsList, ...list];
          this.finished = list.length < this.pageSize;
          if (!this.finished) {
            this.page++;
          }
        })
        .catch(() => {
          Toast('网络错误');
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      if (this.firstfinished && this.inx === 0) {
        this.gettoplist();
      } else {
        this.firstfinished = true;
        getNewstpList({
          page: this.page,
          classId: this.currentArch,
          newsType: 'first',
        })
          .then((res: any) => {
            if (res.statusCode !== 200) {
              Toast(res.message);
              return;
            }
            const list =
              res.data &&
              res.data.data instanceof Array &&
              res.data.data.length > 0 &&
              res.data.data[0].list instanceof Array
                ? res.data.data[0].list
                : [];
            this.newsList = [...this.newsList, ...list];
          })
          .catch(() => {
            Toast('网络错误');
            this.loading = false;
            this.finished = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
  showimgdetail(inx: number) {
    this.isshowimg = true;
    this.showimginx = inx;
  }
  changeshowimginx() {
    this.isshowimg = false;
    this.showimginx = -1;
  }
  setNav(item: number) {
    if (this.currentArch === item + '') {
      return false;
    }
    this.isShowList = false;
    this.currentArch = item + '';
    const tabs1 = getChannelList1();
    for (let i = 0; i < tabs1.length; i++) {
      if (this.currentArch === tabs1[i]) {
        window.localStorage.setItem('nowinx', i + '');
        this.inx = i;
        break;
      }
    }
    this.newsList = [];
    this.finished = false;
    this.loading = false;
    this.finished1 = false;
    this.loading1 = false;
    this.page = 1;
    setTimeout(() => {
      this.isShowList = true;
    }, 50);
    // this.loadData();
    // this.$router.push(`${this.$route.path}?id=${this.currentArch}`);
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
